export default __webpack_public_path__ + "static/media/2337.07009db0.png";